module.exports = "<div class=\"wgt-spinner\">\r\n    <span></span>\r\n    <span></span>\r\n    <span></span>\r\n</div>";